<!-- =========================================================================================
  File Name: CompanyEdit.vue
  Description: Company Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/company/pixinvent
========================================================================================== -->

<template>
  <div id="page-role-view view-page">
    <vs-alert color="danger" title="Audit Not Found" :active.sync="not_found">
      <span>Audit record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'audit.list'}" class="text-inherit underline">All
        Audits</router-link>
      </span>
    </vs-alert>

    <div v-if="data">
    <vs-row >
      <vs-col>
        <vs-row>
          <vs-col>
            <h2 class="mb-4">{{ data.id }}</h2>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col>
            <card-page card-title="Summary">
              <hr class="my-3">
              <div class="vx-row mt-4" v-for="row in summary">
                <div class="vx-col w-full">
                  <div class="vx-row">
                    <div class="vx-col w-1/6"><label class="vs-input--label font-bold">{{  row.label }}</label></div>
                    <div class="vx-col w-1/2">{{ getValue(data, row.dataKey) }}</div>
                  </div>
                </div>
              </div>
              <div class="vx-row mt-4">
                <div class="vx-col w-full">
                  <div class="vx-row">
                    <div class="vx-col w-1/6"><label class="vs-input--label font-bold">User</label></div>
                    <div class="vx-col w-1/2">{{ user }}</div>
                  </div>
                </div>
              </div>

              <vue-json-pretty
                  class="bg-dark text-white p-5 mt-5"
                  :data="data"
                  highlightSelectedNode
              >
              </vue-json-pretty>
            </card-page>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    </div>



  </div>
</template>

<script>


import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css';
import moment from "moment";
import {isFunction} from 'lodash';
import CardPage from '../../../components/Views/CardPage';


export default {
  components: {
    VueJsonPretty,
    CardPage
  },
  data () {
    return {
      data: null,
      not_found: false,
      summary: [
        {
          label: 'Date',
          dataKey: ({CreatedDate}) => moment(CreatedDate).format('MM/DD/yyyy') + ' ' + moment(CreatedDate).format('HH:mm:ss')
        },
        {
          label: 'Entity',
          dataKey: 'Auditable_Type',
        },
        {
          label: 'Entity PK',
          dataKey: 'Auditable_FK',
        },
        {
          label: 'User PK',
          dataKey: 'User_FK',
        },

      ]
    }
  },
  computed: {
    id() {
      return this.data.id;
    },
    user() {
      if (!this.data) {
        return '';
      }

      if (this.data.url === 'console') {
        return 'Console';
      }

      if (!this.data.user) {
        return '';
      }

      return this.data.user.Name;
    }
  },
  methods: {
    async fetch(roleId) {
      try {
        const { data } = await this.$api.audits.get(roleId);
        this.data = data.data;
      } catch (e) {
        console.error(err)
      } finally {
        if (!this.data) {
          this.not_found = true
        }
      }
    },
    /**
     * Get value, allows for callback
     * @param data
     * @param index
     * @returns {*}
     */
    getValue(data, index) {
      if (isFunction(index)) {
        return index(data);
      }

      return data[index];
    }
  },
  mounted () {
    this.fetch(this.$route.params.id)
  }
}

</script>
<style lang="scss">

</style>
